module Elma.Bindings {
    export class CloseVisibleItem {
        public init(element: any, valueAccessor: () => string, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext) {
                return;
            }
            var logger = Ftw.Base.Config.Logger;
            var currentElmSelector = ko.unwrap(valueAccessor());

            if (currentElmSelector) {
                ko.utils.registerEventHandler(element, "click", function (e) {
                    e.preventDefault();
                    var $elm = $(currentElmSelector);
                    if ($elm) {
                        $elm.removeClass("visible");
                        $(".js-backdrop").hide(); 

                        if ($elm.hasClass("ecom")) {
                            $elm.find(".setSubmenu").removeClass("active").hide();
                        }
                    }
                });
            }
            else {
                logger.warning("closeVisibleItem: empty parameter found, remember to define a string that matches your item that needs to be hiddden");
            }
        }
    }
    ko.bindingHandlers['closeVisibleItem'] = new CloseVisibleItem();
} 
